import { map } from 'lodash-es';
import numberMixin from '../../../../mixins/numberMixin';
import statusEnums from '../../../../variables/ski/pass/status-type-enums';
import keyCardPaymentTypeEnums from '../../../../variables/ski/pass/key-card-payment-type-enums';

export default {

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*}
   */
  getSkiPasses(state, getters, rootState, rootGetters) {
    const statePasses = state.pass.items;
    const stateParticipants = rootGetters['booking/getParticipantsWithFullName'];
    const stateBookingStaysWithArea = rootGetters['booking/getBookingStaysWithArea'];
    if (!stateParticipants
      || !stateParticipants.length
      || !statePasses
      || !statePasses.length
      || !stateBookingStaysWithArea
      || !stateBookingStaysWithArea.length
    ) {
      return [];
    }

    const selectedBookingParticipantId = state.search.selectedBookingParticipantId;
    const selectedAreaId = state.search.selectedAreaId;
    const passes = statePasses.filter(pass =>
      pass.bookingParticipantId === selectedBookingParticipantId || !selectedBookingParticipantId,
    ).map((pass) => {
      const participant = stateParticipants.find(stateParticipant =>
        stateParticipant.id === pass.bookingParticipantId,
      );
      const area = rootState.booking.areas.items.find(a => a.id === pass.areaId);
      let statusColor;
      let statusIcon;
      switch (pass.status) {
        case statusEnums.PAID:
          statusColor = 'green';
          statusIcon = 'check_circle';
          break;
        case statusEnums.CANCELLED:
        case statusEnums.STOPPED:
          statusColor = 'red';
          statusIcon = 'warning';
          break;
        default:
          statusColor = 'orange';
          statusIcon = 'watch_later';
          break;
      }
      const priceGross = pass.price;
      const priceNet = pass.priceNet;
      const keyCardGross = pass.keyCardPrice;
      const keyCardNet = pass.keyCardPriceNet;
      let totalGrossAfterDiscount = priceGross;
      let totalNetAfterDiscount = priceNet;
      let discountPercentage;
      let discountGross;
      let discountNet;
      if (pass.discount) {
        discountPercentage = numberMixin.filters.roundNumber((pass.discount / priceGross) / 100);
        discountGross = pass.discount;
        discountNet = pass.discountNet;
        totalGrossAfterDiscount -= pass.discount;
        totalNetAfterDiscount -= pass.discountNet;
        totalGrossAfterDiscount = numberMixin.filters.roundNumber(totalGrossAfterDiscount, 0);
        totalNetAfterDiscount = numberMixin.filters.roundNumber(totalNetAfterDiscount, 0);
      }
      let totalGrossAfterDiscountAndKeyCard = totalGrossAfterDiscount;
      let totalNetAfterDiscountAndKeyCard = totalNetAfterDiscount;
      const hasKeyCard = keyCardGross !== null || keyCardNet !== null;
      if (hasKeyCard) {
        totalGrossAfterDiscountAndKeyCard += numberMixin.filters.roundNumber(keyCardGross);
        totalNetAfterDiscountAndKeyCard += numberMixin.filters.roundNumber(keyCardNet);
      }

      return {
        ...pass,
        area,
        participant,
        statusName: pass.status === statusEnums.INITIATED ? 'Not paid' : pass.status,
        statusColor,
        statusIcon,
        discountPercentage: numberMixin.filters.roundNumber(discountPercentage),
        priceGross: numberMixin.filters.roundNumber(priceGross),
        priceNet: numberMixin.filters.roundNumber(priceNet),
        hasKeyCard,
        keyCardGross: numberMixin.filters.roundNumber(keyCardGross),
        keyCardNet: numberMixin.filters.roundNumber(keyCardNet),
        discountGross: numberMixin.filters.roundNumber(discountGross),
        discountNet: numberMixin.filters.roundNumber(discountNet),
        totalGrossAfterDiscount: numberMixin.filters.roundNumber(totalGrossAfterDiscount),
        totalNetAfterDiscount: numberMixin.filters.roundNumber(totalNetAfterDiscount),
        totalGrossAfterDiscountAndKeyCard:
          numberMixin.filters.roundNumber(totalGrossAfterDiscountAndKeyCard),
        totalNetAfterDiscountAndKeyCard:
          numberMixin.filters.roundNumber(totalNetAfterDiscountAndKeyCard),
        // TODO: SKI-1233 Find person category ages and check booking participant age is valid
        ageMismatch: false,
      };
    });

    return passes.filter(pass => pass.area.id === selectedAreaId || !selectedAreaId)
      .sort((a, b) => a.bookingParticipantId - b.bookingParticipantId);
  },

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*}
   */
  getBookingParticipantsWherePassesExist(state, getters, rootState, rootGetters) {
    const statePasses = state.pass.items;
    const stateParticipants = rootGetters['booking/getParticipantsWithFullName'];
    if (!stateParticipants
      || !stateParticipants.length
      || !statePasses
      || !Object.keys(statePasses).length
    ) {
      return [];
    }
    const allBookingParticipantIds = statePasses.map(
      statePass => statePass.bookingParticipantId,
    );
    const uniqueBookingParticipantIds = [...new Set(allBookingParticipantIds)];
    const availableParticipants = stateParticipants.filter(
      stateParticipant => uniqueBookingParticipantIds.includes(stateParticipant.id),
    );
    const selectAllItem = { fullName: 'Select all', id: null };

    return [selectAllItem, ...availableParticipants];
  },

  /**
   * @param state
   * @param getters
   * @param rootState
   * @param rootGetters
   * @returns {Array|*[]}
   */
  getBookingStayAreasWithAllOption(state, getters, rootState, rootGetters) {
    const stateBookingStayAreas = rootGetters['booking/getBookingStayAreas'];
    if (!stateBookingStayAreas || !stateBookingStayAreas.length) {
      return [];
    }
    const selectAllItem = { name: 'Select all', id: null };

    return [selectAllItem, ...stateBookingStayAreas];
  },

  /**
   * @param state
   * @param getters
   * @returns {undefined|*}
   */
  getAvailableSkiPassProductUsedForChangeProduct(state, getters) {
    const stateAvailablePassProducts = state.availablePassProducts.items;
    const selectedStartDate = state.changeProduct.selectedStartDate;
    if (!selectedStartDate || !stateAvailablePassProducts || !stateAvailablePassProducts.length) {
      return undefined;
    }
    let foundAvailablePassProduct;
    const availablePassProducts = getters.filterAvailablePassProductsByAllFilters(state);
    for (let i = 0; i < availablePassProducts.length; i += 1) {
      let availablePassProduct = availablePassProducts[i];
      const priceGross = availablePassProduct.priceGross;
      const priceNet = availablePassProduct.priceNet;
      let totalGrossAfterDiscount = priceGross;
      let totalNetAfterDiscount = priceNet;
      let discountGross;
      let discountNet;
      if (availablePassProduct.discount && availablePassProduct.discount.id) {
        const discountPercentage = availablePassProduct.discount.percentage / 100;
        discountGross = priceGross * discountPercentage;
        discountNet = priceNet * discountPercentage;
        totalGrossAfterDiscount -= discountGross;
        totalNetAfterDiscount -= discountNet;
      }
      let totalGrossAfterDiscountAndKeyCard = totalGrossAfterDiscount;
      let totalNetAfterDiscountAndKeyCard = totalNetAfterDiscount;
      let keyCardGross = null;
      let keyCardNet = null;
      const hasKeyCard = availablePassProduct.season.keyCardPaymentType
        === keyCardPaymentTypeEnums.MANDATORY;
      if (hasKeyCard && !!availablePassProduct.season.keyCard) {
        keyCardGross = availablePassProduct.keyCardPriceGross;
        keyCardNet = availablePassProduct.keyCardPriceNet;
        totalGrossAfterDiscountAndKeyCard += keyCardGross;
        totalNetAfterDiscountAndKeyCard += keyCardNet;
      }
      availablePassProduct = {
        ...availablePassProduct,
        priceGross: numberMixin.filters.roundNumber(priceGross, 0),
        priceNet: numberMixin.filters.roundNumber(priceNet, 0),
        keyCardPaymentType: availablePassProduct.season.keyCardPaymentType,
        hasKeyCard,
        keyCardGross: numberMixin.filters.roundNumber(keyCardGross, 0),
        keyCardNet: numberMixin.filters.roundNumber(keyCardNet, 0),
        discountGross: numberMixin.filters.roundNumber(discountGross, 0),
        discountNet: numberMixin.filters.roundNumber(discountNet, 0),
        totalGrossAfterDiscount: numberMixin.filters.roundNumber(totalGrossAfterDiscount, 0),
        totalNetAfterDiscount: numberMixin.filters.roundNumber(totalNetAfterDiscount, 0),
        totalGrossAfterDiscountAndKeyCard:
          numberMixin.filters.roundNumber(totalGrossAfterDiscountAndKeyCard, 0),
        totalNetAfterDiscountAndKeyCard:
          numberMixin.filters.roundNumber(totalNetAfterDiscountAndKeyCard, 0),
      };
      foundAvailablePassProduct = availablePassProduct;
      break;
    }

    return foundAvailablePassProduct;
  },

  /**
   * @param state
   * @param getters
   * @returns {this|Array}
   */
  getAvailableSkiPassProducts(state, getters) {
    const stateAvailablePassProducts = state.availablePassProducts.items;
    const selectedStartDate = state.search.selectedStartDate;
    if (!selectedStartDate || !stateAvailablePassProducts || !stateAvailablePassProducts.length) {
      return [];
    }
    const currentBookingPassProducts
      = getters.getBookingPassProductsBySelectedBookingParticipant(state);
    const availablePassProducts = getters.filterAvailablePassProducts(state);
    const defaultPersonCategories = getters.uniquePersonCategoriesFromAvailableSkiPassProducts(
      state,
      getters,
    );
    const productsGrouped = {};
    availablePassProducts.forEach((availablePassProduct) => {
      const personCategoryId = availablePassProduct.personCategory.id;
      const prices = {};
      defaultPersonCategories.forEach((defaultPersonCategory) => {
        if (prices[defaultPersonCategory.id] === undefined) {
          prices[defaultPersonCategory.id] = {};
        }
        let foundAvailablePassPrice;
        let bookingPassProductId;
        let foundPriceId;
        let hasDiscount;
        let foundPersonCategory;
        let foundDiscount;
        if (defaultPersonCategory.id === personCategoryId) {
          foundAvailablePassPrice = availablePassProduct;
          foundPriceId = foundAvailablePassPrice.id;
          hasDiscount = foundAvailablePassPrice.discount && foundAvailablePassPrice.discount.id > 0;
          foundPersonCategory = foundAvailablePassPrice.personCategory;
          foundDiscount = foundAvailablePassPrice.discount;
          const foundBookingPassProduct = currentBookingPassProducts.find(
            bookingPassProduct =>
              bookingPassProduct.seasonId === availablePassProduct.season.id
              && bookingPassProduct.personCategoryId === personCategoryId
              && bookingPassProduct.days === availablePassProduct.days
              && bookingPassProduct.firstSkiDay === selectedStartDate
              && (!bookingPassProduct.deletedAt && !bookingPassProduct.cancelledAt && !bookingPassProduct.stoppedAt),
          );
          if (foundBookingPassProduct) {
            bookingPassProductId = foundBookingPassProduct.id;
          }
        }
        const priceGross = availablePassProduct.priceGross;
        const priceNet = availablePassProduct.priceNet;
        let totalGrossAfterDiscount = priceGross;
        let totalNetAfterDiscount = priceNet;
        if (availablePassProduct.discount && availablePassProduct.discount.id) {
          const discountPercentage = availablePassProduct.discount.percentage / 100;
          const discountGross = numberMixin.filters.roundNumber(priceGross * discountPercentage, 0);
          const discountNet = numberMixin.filters.roundNumber(priceNet * discountPercentage, 0);
          totalGrossAfterDiscount -= discountGross;
          totalNetAfterDiscount -= discountNet;
        }
        let totalGrossAfterDiscountAndKeyCard = totalGrossAfterDiscount;
        let totalNetAfterDiscountAndKeyCard = totalNetAfterDiscount;
        let keyCardGross;
        let keyCardNet;
        const isKeyCardMandatory = availablePassProduct.season.keyCardPaymentType
          === keyCardPaymentTypeEnums.MANDATORY;
        if (isKeyCardMandatory && !!availablePassProduct.season.keyCard) {
          keyCardGross = availablePassProduct.keyCardPriceGross;
          keyCardNet = availablePassProduct.keyCardPriceNet;
          totalGrossAfterDiscountAndKeyCard += keyCardGross;
          totalNetAfterDiscountAndKeyCard += keyCardNet;
        }
        prices[defaultPersonCategory.id] = {
          bookingPassProductId,
          priceGross: numberMixin.filters.roundNumber(priceGross, 0),
          priceNet: numberMixin.filters.roundNumber(priceNet, 0),
          isKeyCardMandatory,
          keyCardGross,
          keyCardNet,
          totalGrossAfterDiscount: numberMixin.filters.roundNumber(totalGrossAfterDiscount, 0),
          totalNetAfterDiscount: numberMixin.filters.roundNumber(totalNetAfterDiscount, 0),
          totalGrossAfterDiscountAndKeyCard:
            numberMixin.filters.roundNumber(totalGrossAfterDiscountAndKeyCard, 0),
          totalNetAfterDiscountAndKeyCard:
            numberMixin.filters.roundNumber(totalNetAfterDiscountAndKeyCard, 0),
          id: foundPriceId,
          personCategory: foundPersonCategory,
          discount: foundDiscount,
          hasDiscount,
        };
      });
      const mergedPrices = prices;
      if (productsGrouped[availablePassProduct.season.id] === undefined) {
        productsGrouped[availablePassProduct.season.id] = {};
      } else {
        const foundPrices = productsGrouped[availablePassProduct.season.id].prices;
        Object.entries(foundPrices).forEach(([pricePersonCategoryId, price]) => {
          if (price.id === undefined) {
            const newPrice = prices[personCategoryId];
            if (newPrice) {
              mergedPrices[personCategoryId] = newPrice;
            }
          } else {
            mergedPrices[pricePersonCategoryId] = price;
          }
        });
      }
      productsGrouped[availablePassProduct.season.id] = {
        product: availablePassProduct,
        prices: mergedPrices,
      };
    });

    return productsGrouped;
  },

  /**
   * @param state
   * @returns {{totalGross: *, totalNet: *}}
   */
  getSkiPassTotalPrice(state) {
    const statePasses = state.pass.items;
    let totalGross = 0;
    let totalNet = 0;
    Object.values(statePasses).forEach((statePass) => {
        if (!statePass.deletedAt && !statePass.cancelledAt && !statePass.stoppedAt) {
          let priceGross = statePass.price;
          let priceNet = statePass.priceNet;
          if (statePass.keyCardPrice || statePass.keyCardPriceNet) {
            priceGross += statePass.keyCardPrice;
            priceNet += statePass.keyCardPriceNet;
          }
          if (statePass.discount) {
            priceGross -= statePass.discount;
            priceNet -= statePass.discountNet;
          }
          if (!statePass.deletedAt && !statePass.cancelledAt && !statePass.stoppedAt) {
            totalGross += priceGross;
            totalNet += priceNet;
          }
        }
    });

    return {
      totalGross: numberMixin.filters.roundNumber(totalGross),
      totalNet: numberMixin.filters.roundNumber(totalNet),
    };
  },

  /**
   * @param state
   * @returns {number}
   */
  getTotalNumberOfSkiPassProducts(state) {
    return state.pass.items ? state.pass.items.length : 0;
  },

  /**
   * @param state
   * @param getters
   * @returns {this|Array}
   */
  getAvailableSkiPassProductsPersonCategoryHeaders(state, getters) {
    const stateAvailablePassProducts = state.availablePassProducts.items;
    if (!stateAvailablePassProducts || !stateAvailablePassProducts.length) {
      return [];
    }

    return getters.uniquePersonCategoriesFromAvailableSkiPassProducts(state, getters);
  },

  /**
   * @returns {number[]}
   */
  getAvailableNumberOfDays() {
    return [2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14];
  },

  /**
   * @returns {Function}
   */
  getBookingPassProductsBySelectedBookingParticipant: () => (state) => {
    const selectedBookingParticipantId = state.search.selectedBookingParticipantId[0];
    const statePassPrices = state.pass.items;
    if (!selectedBookingParticipantId || !statePassPrices.length) {
      return [];
    }
    const statePassPrice = statePassPrices.find(item =>
      item.bookingParticipantId === selectedBookingParticipantId
      && !item.deletedAt
      && !item.cancelledAt
      && !item.stoppedAt,
    );
    if (!statePassPrice) {
      return [];
    }

    return map(statePassPrices, pass => ({
      id: pass.id,
      seasonId: pass.productsSkiPassSeasonId,
      personCategoryId: pass.productsSkiPassPersonCategoryId,
      firstSkiDay: pass.firstSkiDay,
      days: pass.numberOfDays,
      deletedAt: pass.deletedAt,
    }));
  },

  /**
   * @returns {Function}
   */
  uniquePersonCategoriesFromAvailableSkiPassProducts: () => (state, getters) => {
    const stateAvailablePassProducts = state.availablePassProducts.items;
    if (!stateAvailablePassProducts || !stateAvailablePassProducts.length) {
      return [];
    }
    const availablePassProducts = getters.filterAvailablePassProducts(state);
    const uniquePersonCategories = [];
    availablePassProducts.forEach((availablePassProduct) => {
      if (!uniquePersonCategories.some(personCategoryHeader =>
        personCategoryHeader.id === availablePassProduct.personCategory.id,
      )) {
        uniquePersonCategories.push(availablePassProduct.personCategory);
      }
    });

    return uniquePersonCategories;
  },

  /**
   * @returns {Function}
   */
  filterAvailablePassProducts: () => (state) => {
    const stateAvailablePassProducts = state.availablePassProducts.items;
    if (!stateAvailablePassProducts || !stateAvailablePassProducts.length) {
      return [];
    }

    return stateAvailablePassProducts;
  },

  /**
   * @returns {Function}
   */
  filterAvailablePassProductsByAllFilters: () => (state) => {
    const stateAvailablePassProducts = state.availablePassProducts.items;
    if (!stateAvailablePassProducts || !stateAvailablePassProducts.length) {
      return [];
    }
    const selectedPersonCategoryId = state.changeProduct.selectedPersonCategoryId;
    const selectedNumberOfDays = state.changeProduct.selectedNumberOfDays;

    return stateAvailablePassProducts.filter(availablePassProduct => (
      selectedPersonCategoryId === availablePassProduct.personCategory.id
      && selectedNumberOfDays === availablePassProduct.days
    ));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/pass/getters.js